import { IconProps } from '@/root/shared-types/ui/ui-types'
import { FC } from 'react'
import Icon from '@/root/ui/shared/Icon'

export const BottomArrowIcon: FC<IconProps> = ({ width = 19, height = 19, ...rest }) => (
  <Icon type="BottomArrow" width={width} height={height} alt="BottomArrowIcon" {...rest} />
)
